import React from 'react';
import { useDispatch } from 'react-redux';
import METRICS from 'utils/enums/metrics';
import IntervalCatalog from 'utils/enums/interval';
import { ReportTypesId } from 'utils/enums/report';
import runBuilderQuery from 'store/chartBuilder/thunks';
import ChartPreview from './ChartPreview';

const metricOptions = Object.keys(METRICS);

export default function ChartBuilderPage() {
  const dispatch = useDispatch();

  const [selection, setSelection] = React.useState({
    chartType: 'lines',
    dateRange: {
      from: new Date(Date.now() - 7 * 24 * 3600e3).toISOString(),
      to: new Date().toISOString(),
    },
    interval: IntervalCatalog?.custom || 'custom',
    metric: metricOptions[0],
  });

  const update = (patch) => setSelection((s) => ({ ...s, ...patch }));
  const updateDate = (key, value) =>
    setSelection((s) => ({ ...s, dateRange: { ...s.dateRange, [key]: value } }));

  const run = () => dispatch(runBuilderQuery(selection));

  return (
    <div style={{ padding: 24 }}>
      <h1>Chart Builder (Dev)</h1>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(260px, 1fr))',
          gap: 16,
          marginBottom: 16,
        }}
      >
        <label htmlFor="siteId">
          Site ID
          <input
            id="siteId"
            type="number"
            value={selection.siteId || ''}
            onChange={(e) =>
              update({
                siteId: e.target.value ? Number(e.target.value) : undefined,
              })
            }
          />
        </label>

        <label htmlFor="deviceType">
          Device Type (for telemetry)
          <input
            id="deviceType"
            type="text"
            value={selection.deviceType || ''}
            onChange={(e) => update({ deviceType: e.target.value || undefined })}
            placeholder="e.g., PDC"
          />
        </label>

        <label htmlFor="metric">
          Metric
          <select
            id="metric"
            value={selection.metric}
            onChange={(e) => update({ metric: e.target.value })}
          >
            {metricOptions.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </label>

        <label htmlFor="chartType">
          Chart Type
          <select
            id="chartType"
            value={selection.chartType}
            onChange={(e) => update({ chartType: e.target.value })}
          >
            <option value="lines">lines</option>
            <option value="lines-zoom">lines-zoom</option>
            <option value="donut">donut</option>
            <option value="stacked-bar">stacked-bar</option>
          </select>
        </label>

        <label htmlFor="from">
          From
          <input
            id="from"
            type="datetime-local"
            onChange={(e) => updateDate('from', new Date(e.target.value).toISOString())}
          />
        </label>

        <label htmlFor="to">
          To
          <input
            id="to"
            type="datetime-local"
            onChange={(e) => updateDate('to', new Date(e.target.value).toISOString())}
          />
        </label>

        <label htmlFor="aggregation">
          Aggregation
          <select
            id="aggregation"
            value={selection.aggregation || ''}
            onChange={(e) => update({ aggregation: e.target.value || undefined })}
          >
            <option value="">(default)</option>
            <option value="sum">sum</option>
            <option value="avg">avg</option>
            <option value="min">min</option>
            <option value="max">max</option>
          </select>
        </label>

        <label htmlFor="reportType">
          Report Type (for energy/ess/facility families)
          <select
            id="reportType"
            value={selection.reportType || ''}
            onChange={(e) =>
              update({
                reportType: e.target.value ? Number(e.target.value) : undefined,
              })
            }
          >
            <option value="">(none)</option>
            <option value={ReportTypesId?.Energy || 2}>Energy</option>
            <option value={ReportTypesId?.ESS || 3}>ESS</option>
            <option value={ReportTypesId?.Facility || 4}>Facility</option>
          </select>
        </label>
      </div>

      <button type="button" onClick={run}>
        Run
      </button>

      <div style={{ marginTop: 24 }}>
        <ChartPreview />
      </div>
    </div>
  );
}
